import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';

interface FilterDropdownProps {
  label?: string;
  options: string[];
  value?: string | null;
  onSelect: (value: string) => void;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  label = 'Sort by',
  options,
  value,
  onSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option: string) => {
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div className="relative w-fit text-sm">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between gap-4  px-4 py-2.5  text-gray-700 bg-white border border-gray-300 rounded-xl shadow-sm focus:outline-none"
      >
        <span className={!value ? 'opacity-60' : ''}>
          {value ? value : label}
        </span>
        <FiChevronDown className="text-gray-500" />
      </button>

      {isOpen && (
        <div className="absolute left-0 w-full mt-2 bg-white border border-gray-200 rounded-xl shadow-lg">
          {options.map((option) => (
            <button
              key={option}
              onClick={() => handleSelect(option)}
              className="w-full px-4 py-2 text-left hover:bg-gray-100"
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
